function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 365,
    style: {
      fill: "#ebf5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.37,336.45c61.56,55.7,113.91-43.2,196.66-40.65,127.5,3.92,208.63-37.38,207.56-110.7S1212.38,43,1082.28,74.47,842,257.39,929.37,336.45Z",
    style: {
      fill: "#4e97fd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.1,
    y: 34.65,
    width: 16.4,
    height: 65.11,
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.1,
    y: 34.65,
    width: 16.4,
    height: 65.11,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1114.1 34.66 1130.5 34.66 1135.53 30.84 1109.08 30.84 1114.1 34.66",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.09,
    y: 16.02,
    width: 10.44,
    height: 14.83,
    style: {
      fill: "#d0e0fc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.09,
    y: 16.02,
    width: 10.44,
    height: 14.83,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.23,16h18.14a1.37,1.37,0,0,0,1.37-1.37h0a1.37,1.37,0,0,0-1.37-1.37h-18.14a1.37,1.37,0,0,0-1.36,1.37h0A1.36,1.36,0,0,0,1113.23,16Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.84,
    y: 34.65,
    width: 10.93,
    height: 38.02,
    style: {
      fill: "#d0e0fc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1116.84,
    y: 34.65,
    width: 10.93,
    height: 38.02,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.87,113.68h8.86a0,0,0,0,1,0,0V125.2a1.65,1.65,0,0,1-1.65,1.65h-5.57a1.65,1.65,0,0,1-1.65-1.65V113.68A0,0,0,0,1,1117.87,113.68Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1126.73 113.68 1117.87 113.68 1114.1 99.76 1130.5 99.76 1126.73 113.68",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.84,72.67h10.93V91.06a5.47,5.47,0,0,1-5.47,5.47h0a5.46,5.46,0,0,1-5.46-5.47Z",
    style: {
      fill: "#4e97fd"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1122.3,
    y1: 96.53,
    x2: 1122.3,
    y2: 126.85,
    style: {
      fill: "none",
      stroke: "#32cc98",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.84,72.67h10.93V91.06a5.47,5.47,0,0,1-5.47,5.47h0a5.46,5.46,0,0,1-5.46-5.47Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1126.73 113.68 1117.87 113.68 1114.1 99.76 1130.5 99.76 1126.73 113.68",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.87,113.68h8.86a0,0,0,0,1,0,0V125.2a1.65,1.65,0,0,1-1.65,1.65h-5.57a1.65,1.65,0,0,1-1.65-1.65V113.68A0,0,0,0,1,1117.87,113.68Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1122.3,
    y1: 126.85,
    x2: 1122.3,
    y2: 143.06,
    style: {
      fill: "none",
      stroke: "#32cc98",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1121.56 143.06 1123.05 143.06 1123.8 126.85 1120.81 126.85 1121.56 143.06",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.3,143.06h-.74l.31,44.82a.44.44,0,0,0,.43.43h0a.43.43,0,0,0,.43-.43l.32-44.82Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.05,96.53",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.39,195.12c.94,0,.63,1.9,1,3.27.69,2.53-1,3.94-2.54,2.81S1118.9,195.16,1120.39,195.12Z",
    style: {
      fill: "#32cc98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.39,195.12c.94,0,.63,1.9,1,3.27.69,2.53-1,3.94-2.54,2.81S1118.9,195.16,1120.39,195.12Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.58,208.86c1.15,0,1,1.53,1.66,2.48s1,3-.24,3.17C1123.73,214.72,1122.51,208.9,1124.58,208.86Z",
    style: {
      fill: "#32cc98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.58,208.86c1.15,0,1,1.53,1.66,2.48s1,3-.24,3.17C1123.73,214.72,1122.51,208.9,1124.58,208.86Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.06,80.62h66a0,0,0,0,1,0,0v93.85a8.54,8.54,0,0,1-8.54,8.54h-48.9a8.54,8.54,0,0,1-8.54-8.54V80.62A0,0,0,0,1,1166.06,80.62Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232,80.62h-15.91v84a8.89,8.89,0,0,1-8.89,8.9H1166.8A14,14,0,0,0,1180,183h38.07a13.43,13.43,0,0,0,2-.16l.42-.06a16,16,0,0,0,1.87-.46l.25-.1a13.82,13.82,0,0,0,1.68-.7l.21-.11a14.89,14.89,0,0,0,1.67-1l.2-.16a14,14,0,0,0,2.85-2.84l.09-.12a13.79,13.79,0,0,0,2-3.75h0a13.79,13.79,0,0,0,.74-4.47Z",
    style: {
      fill: "#d0e0fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.06,80.62h66a0,0,0,0,1,0,0v93.85a8.54,8.54,0,0,1-8.54,8.54h-48.9a8.54,8.54,0,0,1-8.54-8.54V80.62A0,0,0,0,1,1166.06,80.62Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1163.43,
    y: 60.91,
    width: 71.24,
    height: 19.68,
    rx: 1.69,
    style: {
      fill: "#f16880"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.91,60.91h-15.79V80.6h15.79a2.76,2.76,0,0,0,2.75-2.76V63.67A2.76,2.76,0,0,0,1231.91,60.91Z",
    style: {
      fill: "#db5270"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1192.75,
    y1: 60.91,
    x2: 1192.75,
    y2: 80.6,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1186.46,
    y1: 60.91,
    x2: 1186.46,
    y2: 80.6,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1180.16,
    y1: 60.91,
    x2: 1180.16,
    y2: 80.6,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1173.87,
    y1: 60.91,
    x2: 1173.87,
    y2: 80.6,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1167.57,
    y1: 60.91,
    x2: 1167.57,
    y2: 80.6,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1211.64,
    y1: 60.91,
    x2: 1211.64,
    y2: 80.6,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1205.34,
    y1: 60.91,
    x2: 1205.34,
    y2: 80.6,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1199.05,
    y1: 60.91,
    x2: 1199.05,
    y2: 80.6,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1217.93,
    y1: 60.91,
    x2: 1217.93,
    y2: 80.6,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1224.22,
    y1: 60.91,
    x2: 1224.22,
    y2: 80.6,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1230.52,
    y1: 60.91,
    x2: 1230.52,
    y2: 80.6,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1163.43,
    y: 60.91,
    width: 71.24,
    height: 19.68,
    rx: 1.69,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1178.81,
    y: 114.85,
    width: 53.23,
    height: 30.8,
    style: {
      fill: "#2f497e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216.12,
    y: 114.85,
    width: 15.91,
    height: 30.8,
    style: {
      fill: "#243f66"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200.21,
    y: 123.76,
    width: 31.83,
    height: 6.49,
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200.21,
    y: 123.76,
    width: 31.83,
    height: 6.49,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1178.81,
    y: 114.85,
    width: 53.23,
    height: 30.8,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.66,129.9h50.28a0,0,0,0,1,0,0v85.15a6.05,6.05,0,0,1-6.05,6.05h-38.18a6.05,6.05,0,0,1-6.05-6.05V129.9A0,0,0,0,1,1035.66,129.9Z",
    style: {
      fill: "#4e97fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047,148.21h13.41a3.46,3.46,0,0,0,3.45-3.45h0a3.45,3.45,0,0,0-3.45-3.45H1047a3.44,3.44,0,0,0-3.45,3.45h0A3.45,3.45,0,0,0,1047,148.21Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047,148.21h13.41a3.46,3.46,0,0,0,3.45-3.45h0a3.45,3.45,0,0,0-3.45-3.45H1047a3.44,3.44,0,0,0-3.45,3.45h0A3.45,3.45,0,0,0,1047,148.21Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047,148.21h6.83v-6.9H1047a3.44,3.44,0,0,0-3.45,3.45h0A3.45,3.45,0,0,0,1047,148.21Z",
    style: {
      fill: "#f16880"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047,148.21h6.83v-6.9H1047a3.44,3.44,0,0,0-3.45,3.45h0A3.45,3.45,0,0,0,1047,148.21Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068,191l-9.48-9.48a3.45,3.45,0,0,0-4.88,0h0a3.46,3.46,0,0,0,0,4.88l9.48,9.48a3.46,3.46,0,0,0,4.88,0h0A3.45,3.45,0,0,0,1068,191Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068,191l-9.48-9.48a3.45,3.45,0,0,0-4.88,0h0a3.46,3.46,0,0,0,0,4.88l9.48,9.48a3.46,3.46,0,0,0,4.88,0h0A3.45,3.45,0,0,0,1068,191Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068,191l-4.83-4.84-4.88,4.88,4.83,4.84a3.46,3.46,0,0,0,4.88,0h0A3.45,3.45,0,0,0,1068,191Z",
    style: {
      fill: "#f16880"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068,191l-4.83-4.84-4.88,4.88,4.83,4.84a3.46,3.46,0,0,0,4.88,0h0A3.45,3.45,0,0,0,1068,191Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.28,197.6V211a3.44,3.44,0,0,0,3.45,3.45h0a3.45,3.45,0,0,0,3.45-3.45V197.6a3.45,3.45,0,0,0-3.45-3.45h0A3.44,3.44,0,0,0,1046.28,197.6Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.28,197.6V211a3.44,3.44,0,0,0,3.45,3.45h0a3.45,3.45,0,0,0,3.45-3.45V197.6a3.45,3.45,0,0,0-3.45-3.45h0A3.44,3.44,0,0,0,1046.28,197.6Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.28,197.6v6.83h6.9V197.6a3.45,3.45,0,0,0-3.45-3.45h0A3.44,3.44,0,0,0,1046.28,197.6Z",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.28,197.6v6.83h6.9V197.6a3.45,3.45,0,0,0-3.45-3.45h0A3.44,3.44,0,0,0,1046.28,197.6Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.22,193.39V180a3.44,3.44,0,0,0-3.45-3.45h0a3.45,3.45,0,0,0-3.45,3.45v13.41a3.46,3.46,0,0,0,3.45,3.45h0A3.45,3.45,0,0,0,1081.22,193.39Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.22,193.39V180a3.44,3.44,0,0,0-3.45-3.45h0a3.45,3.45,0,0,0-3.45,3.45v13.41a3.46,3.46,0,0,0,3.45,3.45h0A3.45,3.45,0,0,0,1081.22,193.39Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.22,193.39v-6.84h-6.9v6.84a3.46,3.46,0,0,0,3.45,3.45h0A3.45,3.45,0,0,0,1081.22,193.39Z",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.22,193.39v-6.84h-6.9v6.84a3.46,3.46,0,0,0,3.45,3.45h0A3.45,3.45,0,0,0,1081.22,193.39Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.8,145.77l-9.49,9.48a3.46,3.46,0,0,0,0,4.88h0a3.45,3.45,0,0,0,4.88,0l9.48-9.48a3.45,3.45,0,0,0,0-4.88h0A3.43,3.43,0,0,0,1073.8,145.77Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.8,145.77l-9.49,9.48a3.46,3.46,0,0,0,0,4.88h0a3.45,3.45,0,0,0,4.88,0l9.48-9.48a3.45,3.45,0,0,0,0-4.88h0A3.43,3.43,0,0,0,1073.8,145.77Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.8,145.77,1069,150.6l4.88,4.88,4.83-4.83a3.45,3.45,0,0,0,0-4.88h0A3.43,3.43,0,0,0,1073.8,145.77Z",
    style: {
      fill: "#32cc98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.8,145.77,1069,150.6l4.88,4.88,4.83-4.83a3.45,3.45,0,0,0,0-4.88h0A3.43,3.43,0,0,0,1073.8,145.77Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.64,200.9l-9.48,9.49a3.43,3.43,0,0,0,0,4.87h0a3.45,3.45,0,0,0,4.88,0l9.48-9.48a3.45,3.45,0,0,0,0-4.88h0A3.46,3.46,0,0,0,1072.64,200.9Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.64,200.9l-9.48,9.49a3.43,3.43,0,0,0,0,4.87h0a3.45,3.45,0,0,0,4.88,0l9.48-9.48a3.45,3.45,0,0,0,0-4.88h0A3.46,3.46,0,0,0,1072.64,200.9Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.64,200.9l-4.83,4.84,4.87,4.88,4.84-4.84a3.45,3.45,0,0,0,0-4.88h0A3.46,3.46,0,0,0,1072.64,200.9Z",
    style: {
      fill: "#32cc98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.64,200.9l-4.83,4.84,4.87,4.88,4.84-4.84a3.45,3.45,0,0,0,0-4.88h0A3.46,3.46,0,0,0,1072.64,200.9Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.49,221.11h4.56a9.89,9.89,0,0,0,9.89-9.9V129.9h-14.45Z",
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.66,129.9h50.28a0,0,0,0,1,0,0v85.15a6.05,6.05,0,0,1-6.05,6.05h-38.18a6.05,6.05,0,0,1-6.05-6.05V129.9A0,0,0,0,1,1035.66,129.9Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.44,111.71h46.72a2.43,2.43,0,0,1,2.43,2.43v11.35a0,0,0,0,1,0,0H1035a0,0,0,0,1,0,0V114.14A2.43,2.43,0,0,1,1037.44,111.71Z",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.62,111.71h-11.13v13.78h15.1v-9.81A4,4,0,0,0,1082.62,111.71Z",
    style: {
      fill: "#6194d6"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1060.8,
    y1: 111.71,
    x2: 1060.8,
    y2: 125.49,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1056.17,
    y1: 111.71,
    x2: 1056.17,
    y2: 125.49,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1051.53,
    y1: 111.71,
    x2: 1051.53,
    y2: 125.49,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1046.89,
    y1: 111.71,
    x2: 1046.89,
    y2: 125.49,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1042.26,
    y1: 111.71,
    x2: 1042.26,
    y2: 125.49,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1037.62,
    y1: 111.95,
    x2: 1037.62,
    y2: 125.49,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1074.71,
    y1: 111.71,
    x2: 1074.71,
    y2: 125.49,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1070.07,
    y1: 111.71,
    x2: 1070.07,
    y2: 125.49,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1065.44,
    y1: 111.71,
    x2: 1065.44,
    y2: 125.49,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1083.98,
    y1: 111.91,
    x2: 1083.98,
    y2: 125.49,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1079.35,
    y1: 111.71,
    x2: 1079.35,
    y2: 125.49,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035,125.49h51.58a2.2,2.2,0,0,1,2.21,2.2h0a2.21,2.21,0,0,1-2.21,2.21H1035a2.21,2.21,0,0,1-2.2-2.21h0A2.2,2.2,0,0,1,1035,125.49Z",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.59,125.49h-15.1v4.41h15.1a2.21,2.21,0,1,0,0-4.41Z",
    style: {
      fill: "#6194d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035,125.49h51.58a2.2,2.2,0,0,1,2.21,2.2h0a2.21,2.21,0,0,1-2.21,2.21H1035a2.21,2.21,0,0,1-2.2-2.21h0A2.2,2.2,0,0,1,1035,125.49Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.44,111.71h46.72a2.43,2.43,0,0,1,2.43,2.43v11.35a0,0,0,0,1,0,0H1035a0,0,0,0,1,0,0V114.14A2.43,2.43,0,0,1,1037.44,111.71Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1035.66,
    y: 155.93,
    width: 50.28,
    height: 27.82,
    style: {
      fill: "#2f497e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1035.66,
    y: 155.93,
    width: 50.28,
    height: 27.82,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1071.49,
    y: 155.93,
    width: 14.45,
    height: 27.82,
    style: {
      fill: "#243f66"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.89,
    y: 161.86,
    width: 31.83,
    height: 6.31,
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.89,
    y: 161.86,
    width: 31.83,
    height: 6.31,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.77,215.27a4.05,4.05,0,0,1-4-4.06V138a4.06,4.06,0,0,1,8.11,0v73.2A4.06,4.06,0,0,1,1043.77,215.27Z",
    style: {
      fill: "#f9fbfc",
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.42,352.87h-16.79A13.68,13.68,0,0,1,1121,339.19V286.37c0-8.26,6.7-25.86,15-25.86h14.22c8.26,0,15,17.6,15,25.86v52.82A13.67,13.67,0,0,1,1151.42,352.87Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.1,286.37c0-7.57-5.62-23-12.92-25.49v76.79a7.08,7.08,0,0,1-7.08,7.08h-23a13.68,13.68,0,0,0,12.49,8.12h16.79c.26,0,.51,0,.76-.06v0c.21,0,.42,0,.62-.06.45,0,.89-.11,1.32-.2s.6-.12.89-.2l.81-.25c.33-.11.65-.24,1-.37l.88-.41c.34-.18.67-.37,1-.57l.53-.34a13,13,0,0,0,1.25-1l.19-.18a12.37,12.37,0,0,0,1.07-1.1,2.85,2.85,0,0,0,.23-.26,14.81,14.81,0,0,0,1.06-1.44h0a14.07,14.07,0,0,0,.86-1.63.41.41,0,0,0,.05-.09h0a13.4,13.4,0,0,0,1.2-5.56Z",
    style: {
      fill: "#d0e0fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.42,352.87h-16.79A13.68,13.68,0,0,1,1121,339.19V286.37c0-8.26,6.7-25.86,15-25.86h14.22c8.26,0,15,17.6,15,25.86v52.82A13.67,13.67,0,0,1,1151.42,352.87Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128,249h30a2.77,2.77,0,0,1,2.77,2.77v11.83a1.95,1.95,0,0,1-1.95,1.95h-31.68a1.95,1.95,0,0,1-1.95-1.95V251.76A2.77,2.77,0,0,1,1128,249Z",
    style: {
      fill: "#f16880"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.28,249h-4.1v16.56h5.45a3.18,3.18,0,0,0,3.18-3.18v-8.84A4.53,4.53,0,0,0,1156.28,249Z",
    style: {
      fill: "#db5270"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1143.03,
    y1: 248.98,
    x2: 1143.03,
    y2: 265.54,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1138.45,
    y1: 248.98,
    x2: 1138.45,
    y2: 265.54,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1133.87,
    y1: 248.98,
    x2: 1133.87,
    y2: 265.54,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1129.29,
    y1: 248.98,
    x2: 1129.29,
    y2: 265.54,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1156.76,
    y1: 248.98,
    x2: 1156.76,
    y2: 265.54,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1152.18,
    y1: 248.98,
    x2: 1152.18,
    y2: 265.54,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1147.61,
    y1: 248.98,
    x2: 1147.61,
    y2: 265.54,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128,249h30a2.77,2.77,0,0,1,2.77,2.77v11.83a1.95,1.95,0,0,1-1.95,1.95h-31.68a1.95,1.95,0,0,1-1.95-1.95V251.76A2.77,2.77,0,0,1,1128,249Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120.95,
    y: 288.19,
    width: 15.78,
    height: 49.57,
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120.95,
    y: 288.19,
    width: 15.78,
    height: 49.57,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120.95,
    y: 288.19,
    width: 15.78,
    height: 12.8,
    style: {
      fill: "#2f497e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1120.95,
    y: 288.19,
    width: 15.78,
    height: 12.8,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.93,289.14h97a0,0,0,0,1,0,0V327.9a9.44,9.44,0,0,1-9.44,9.44h-78.13a9.44,9.44,0,0,1-9.44-9.44V289.14A0,0,0,0,1,1217.93,289.14Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.93,289.14h97a0,0,0,0,1,0,0V327.9a9.44,9.44,0,0,1-9.44,9.44h-78.13a9.44,9.44,0,0,1-9.44-9.44V289.14A0,0,0,0,1,1217.93,289.14Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.54,326.31h-82a15.44,15.44,0,0,0,14.78,11h66.16a15.42,15.42,0,0,0,15.42-15.43V289.14h-14.39Z",
    style: {
      fill: "#d0e0fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.93,289.14h97a0,0,0,0,1,0,0V327.9a9.44,9.44,0,0,1-9.44,9.44h-78.13a9.44,9.44,0,0,1-9.44-9.44V289.14A0,0,0,0,1,1217.93,289.14Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.93,329.49h72a15.31,15.31,0,0,0,2-7.58V298.47h-74Z",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.54,304.22v25.27h12.39a15.31,15.31,0,0,0,2-7.58V304.22Z",
    style: {
      fill: "#6194d6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240.93,
    y: 298.47,
    width: 74,
    height: 9.58,
    style: {
      fill: "#2f497e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1241.25,
    y: 326.31,
    width: 62.08,
    height: 3.18,
    transform: "translate(2544.58 655.8) rotate(180)",
    style: {
      fill: "#6194d6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300.54,
    y: 298.47,
    width: 14.39,
    height: 9.58,
    style: {
      fill: "#243f66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.93,329.49h72a15.31,15.31,0,0,0,2-7.58V298.47h-74Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1240.93,
    y: 298.47,
    width: 74,
    height: 9.58,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1245.5,
    y: 301.37,
    width: 38.78,
    height: 3.78,
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1245.5,
    y: 301.37,
    width: 38.78,
    height: 3.78,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1245.5,
    y: 316.59,
    width: 60.16,
    height: 3.27,
    style: {
      fill: "#2f497e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1245.5,
    y: 316.59,
    width: 60.16,
    height: 3.27,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.8,270.83h89.26a3.87,3.87,0,0,1,3.87,3.87v14.43a0,0,0,0,1,0,0h-97a0,0,0,0,1,0,0V274.7A3.87,3.87,0,0,1,1221.8,270.83Z",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.6,270.83h-8.06v18.31h14.39v-12A6.32,6.32,0,0,0,1308.6,270.83Z",
    style: {
      fill: "#6194d6"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1260.14,
    y1: 270.83,
    x2: 1260.14,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1253.84,
    y1: 270.83,
    x2: 1253.84,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1247.55,
    y1: 270.83,
    x2: 1247.55,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1241.25,
    y1: 270.83,
    x2: 1241.25,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1234.96,
    y1: 270.83,
    x2: 1234.96,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1228.66,
    y1: 270.83,
    x2: 1228.66,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1222.37,
    y1: 271.12,
    x2: 1222.37,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1279.02,
    y1: 270.83,
    x2: 1279.02,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1272.73,
    y1: 270.83,
    x2: 1272.73,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1266.43,
    y1: 270.83,
    x2: 1266.43,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1285.31,
    y1: 270.83,
    x2: 1285.31,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1291.61,
    y1: 270.83,
    x2: 1291.61,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1297.9,
    y1: 270.83,
    x2: 1297.9,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1304.2,
    y1: 270.83,
    x2: 1304.2,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1310.49,
    y1: 271.12,
    x2: 1310.49,
    y2: 289.14,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.8,270.83h89.26a3.87,3.87,0,0,1,3.87,3.87v14.43a0,0,0,0,1,0,0h-97a0,0,0,0,1,0,0V274.7A3.87,3.87,0,0,1,1221.8,270.83Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1263.7,
    y: 168.07,
    width: 114.12,
    height: 81.06,
    transform: "translate(281.25 -632.43) rotate(30)",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1390.44 202.03 1383.66 198.12 1347.1 261.44 1255.04 208.3 1251.08 215.17 1349.91 272.23 1390.44 202.03",
    style: {
      fill: "#d0e0fc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1263.7,
    y: 168.07,
    width: 114.12,
    height: 81.06,
    transform: "translate(281.25 -632.43) rotate(30)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.94,
    y: 144.76,
    width: 20.86,
    height: 81.06,
    transform: "translate(264.19 -615.37) rotate(30)",
    style: {
      fill: "#6194d6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.94,
    y: 144.76,
    width: 20.86,
    height: 81.06,
    transform: "translate(264.19 -615.37) rotate(30)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1295.76,
    y: 188.68,
    width: 71.86,
    height: 43.7,
    transform: "matrix(0.87, 0.5, -0.5, 0.87, 283.68, -637.64)",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1295.76,
    y: 188.68,
    width: 71.86,
    height: 43.7,
    transform: "matrix(0.87, 0.5, -0.5, 0.87, 283.68, -637.64)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1304.31,
    y: 190.97,
    width: 71.86,
    height: 9.49,
    transform: "translate(277.41 -643.9) rotate(30)",
    style: {
      fill: "#2f497e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1304.31,
    y: 190.97,
    width: 71.86,
    height: 9.49,
    transform: "translate(277.41 -643.9) rotate(30)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310.64,
    y: 186.95,
    width: 38.78,
    height: 5.74,
    transform: "translate(273.1 -639.58) rotate(30)",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1310.64,
    y: 186.95,
    width: 38.78,
    height: 5.74,
    transform: "translate(273.1 -639.58) rotate(30)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1302.65,
    y: 205.03,
    width: 61.25,
    height: 3.27,
    transform: "translate(281.96 -638.95) rotate(30)",
    style: {
      fill: "#2f497e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1299.5,
    y: 210.49,
    width: 61.25,
    height: 3.27,
    transform: "translate(284.26 -636.64) rotate(30)",
    style: {
      fill: "#2f497e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1299.3,
    y: 204.94,
    width: 17.25,
    height: 3.27,
    transform: "translate(278.52 -626.28) rotate(30)",
    style: {
      fill: "#2f497e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1302.65,
    y: 205.03,
    width: 61.25,
    height: 3.27,
    transform: "translate(281.96 -638.95) rotate(30)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1299.5,
    y: 210.49,
    width: 61.25,
    height: 3.27,
    transform: "translate(284.26 -636.64) rotate(30)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1299.3,
    y: 204.94,
    width: 17.25,
    height: 3.27,
    transform: "translate(278.52 -626.28) rotate(30)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.08,322.31l9.48,9.48a3.45,3.45,0,0,0,4.88,0h0a3.45,3.45,0,0,0,0-4.88l-9.48-9.48a3.46,3.46,0,0,0-4.88,0h0A3.45,3.45,0,0,0,1002.08,322.31Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.08,322.31l4.83,4.84,4.88-4.88-4.83-4.84a3.46,3.46,0,0,0-4.88,0h0A3.45,3.45,0,0,0,1002.08,322.31Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.18,322l-15.64,15.64a18,18,0,0,1-25.47,0L962.9,288.42c-7.69-7.69-17.84-30.32-10.15-38L966,237.17c7.69-7.69,30.32,2.46,38,10.15l49.18,49.17A18,18,0,0,1,1053.18,322Z",
    style: {
      fill: "#4e97fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.18,322l-15.64,15.64a18,18,0,0,1-25.47,0L962.9,288.42c-7.69-7.69-17.84-30.32-10.15-38L966,237.17c7.69-7.69,30.32,2.46,38,10.15l49.18,49.17A18,18,0,0,1,1053.18,322Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.9,333.77a12.6,12.6,0,0,0,17.82,0l15.63-15.63a12.6,12.6,0,0,0,0-17.82l-15.63-15.64-67-.08Z",
    style: {
      fill: "#f16880"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966,237.17l-.58.58,86,86,1.78-1.78a18,18,0,0,0,0-25.47L1004,247.32C996.31,239.63,973.68,229.48,966,237.17Z",
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.68,334.73a4.07,4.07,0,0,1-5.74,0l-49.17-49.17c-3.67-3.67-7.31-10.09-9.75-17.16a4.06,4.06,0,0,1,7.68-2.64c2,5.79,5,11.31,7.81,14.06L1020.68,329A4.07,4.07,0,0,1,1020.68,334.73Z",
    style: {
      fill: "#f9fbfc",
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.24,229.48h30.4a2.81,2.81,0,0,1,2.81,2.81v14a0,0,0,0,1,0,0h-36a0,0,0,0,1,0,0v-14A2.81,2.81,0,0,1,938.24,229.48Z",
    transform: "translate(111.06 743.86) rotate(-45)",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957,222.45l-3.45,3.45,11.85,11.85,6.7-6.69-8.61-8.61A4.59,4.59,0,0,0,957,222.45Z",
    style: {
      fill: "#6194d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.24,229.48h30.4a2.81,2.81,0,0,1,2.81,2.81v14a0,0,0,0,1,0,0h-36a0,0,0,0,1,0,0v-14A2.81,2.81,0,0,1,938.24,229.48Z",
    transform: "translate(111.06 743.86) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 947.52,
    y1: 231.94,
    x2: 959.37,
    y2: 243.79,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 944.24,
    y1: 235.22,
    x2: 956.09,
    y2: 247.07,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 940.96,
    y1: 238.49,
    x2: 952.81,
    y2: 250.35,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 937.68,
    y1: 241.77,
    x2: 949.54,
    y2: 253.63,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 957.35,
    y1: 222.1,
    x2: 969.21,
    y2: 233.96,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 954.07,
    y1: 225.38,
    x2: 965.93,
    y2: 237.23,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 950.8,
    y1: 228.66,
    x2: 962.65,
    y2: 240.51,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 991.87,
    y: 265.72,
    width: 39.41,
    height: 34.06,
    transform: "translate(96.35 798.1) rotate(-45)",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1007.98,
    y: 259.05,
    width: 20.52,
    height: 34.06,
    transform: "translate(103.02 800.87) rotate(-45)",
    style: {
      fill: "#6194d6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 991.87,
    y: 265.72,
    width: 39.41,
    height: 34.06,
    transform: "translate(96.35 798.1) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1018.78 271.5 1012.98 277.29 1007.19 271.5 1002.42 276.27 1008.21 282.06 1002.42 287.86 1007.19 292.63 1012.98 286.84 1018.78 292.63 1023.55 287.86 1017.76 282.06 1023.55 276.27 1018.78 271.5",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1007.19 271.5 1003.17 275.51 1019.53 291.88 1023.55 287.86 1017.76 282.06 1023.55 276.27 1018.78 271.5 1012.98 277.29 1007.19 271.5",
    style: {
      fill: "#d0e0fc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1018.78 271.5 1012.98 277.29 1007.19 271.5 1002.42 276.27 1008.21 282.06 1002.42 287.86 1007.19 292.63 1012.98 286.84 1018.78 292.63 1023.55 287.86 1017.76 282.06 1023.55 276.27 1018.78 271.5",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.89,60c-.42,2.9,3.45,2,5.81,3.94s5-.61,3.73-2.76S1305.38,56.65,1304.89,60Z",
    style: {
      fill: "#4e97fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.89,60c-.42,2.9,3.45,2,5.81,3.94s5-.61,3.73-2.76S1305.38,56.65,1304.89,60Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.15,50.41c-2.59,1.74-7.09-2.46-8.12-6s3.19-6.23,6.44-3.41S1311.18,48.38,1308.15,50.41Z",
    style: {
      fill: "#4e97fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.15,50.41c-2.59,1.74-7.09-2.46-8.12-6s3.19-6.23,6.44-3.41S1311.18,48.38,1308.15,50.41Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1352.2,81.11a14.55,14.55,0,0,1,6.39,0c3,.82,7.15-2.45,5.14-5.33s-5.41,0-7.49,1.2-9-1.67-10.89.4.64,5.39.64,5.39Z",
    style: {
      fill: "#4e97fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1352.2,81.11a14.55,14.55,0,0,1,6.39,0c3,.82,7.15-2.45,5.14-5.33s-5.41,0-7.49,1.2-9-1.67-10.89.4.64,5.39.64,5.39Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.89,80.39s-6.69-5.62-7.15-10.4,4.21-6.25,7.15-1.7,5.82,6.09,8.29,5.55,3.41,7.36,3.41,7.36Z",
    style: {
      fill: "#4e97fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.89,80.39s-6.69-5.62-7.15-10.4,4.21-6.25,7.15-1.7,5.82,6.09,8.29,5.55,3.41,7.36,3.41,7.36Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.79,54.85c-6.36.8-5.42,8.09-7.69,9.7s-6.49-1.81-8.5,1,.74,10-5,10.3a10.29,10.29,0,0,1-1.11,0l.46,9.38,9.94-2.67c0-3.21,1.21-4.41,5.09-4.88s2.4-6.82,5.28-9.49,6.75.53,9.29-3.28S1365.14,54.05,1358.79,54.85Z",
    style: {
      fill: "#4e97fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.79,54.85c-6.36.8-5.42,8.09-7.69,9.7s-6.49-1.81-8.5,1,.74,10-5,10.3a10.29,10.29,0,0,1-1.11,0l.46,9.38,9.94-2.67c0-3.21,1.21-4.41,5.09-4.88s2.4-6.82,5.28-9.49,6.75.53,9.29-3.28S1365.14,54.05,1358.79,54.85Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.06,89.18c-1.39-3.3-8.68-7.11-12.56-9.66s-4.61-8.09,0-8.75,8.7,7.62,16,6.41,10,4.83,10.51,8.27Z",
    style: {
      fill: "#4e97fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.06,89.18c-1.39-3.3-8.68-7.11-12.56-9.66s-4.61-8.09,0-8.75,8.7,7.62,16,6.41,10,4.83,10.51,8.27Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.53,34.56V29.65a5.7,5.7,0,0,0-5-5.74,5.53,5.53,0,0,0-6.07,5.5v5.15a7.92,7.92,0,0,1-7.91,7.92h-2.16V51.7h31.2V42.48h-2.16A7.92,7.92,0,0,1,1341.53,34.56Z",
    style: {
      fill: "#f16880"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.53,34.56V29.65a5.7,5.7,0,0,0-5-5.74,5.53,5.53,0,0,0-6.07,5.5v5.15a7.92,7.92,0,0,1-7.91,7.92h-2.16V51.7h31.2V42.48h-2.16A7.92,7.92,0,0,1,1341.53,34.56Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320.4,
    y1: 42.48,
    x2: 1351.6,
    y2: 42.48,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336,94.45h0a3.56,3.56,0,0,1-3.57-3.56V51.7h7.13V90.89A3.56,3.56,0,0,1,1336,94.45Z",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336,94.45h0a3.56,3.56,0,0,1-3.57-3.56V51.7h7.13V90.89A3.56,3.56,0,0,1,1336,94.45Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.63,84.21h31.2a0,0,0,0,1,0,0v48.88a6,6,0,0,1-6,6h-19.21a6,6,0,0,1-6-6V84.21a0,0,0,0,1,0,0Z",
    transform: "translate(16.91 351.72) rotate(-15)",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1352.2,81.11l-5.87,1.57,12.29,45.85.09.13-24,6.43a9.82,9.82,0,0,0,11,4.56l11.19-3a9.81,9.81,0,0,0,6.94-12Z",
    style: {
      fill: "#d0e0fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.63,84.21h31.2a0,0,0,0,1,0,0v48.88a6,6,0,0,1-6,6h-19.21a6,6,0,0,1-6-6V84.21a0,0,0,0,1,0,0Z",
    transform: "translate(16.91 351.72) rotate(-15)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1328.31,
    y: 93.9,
    width: 22.29,
    height: 34.28,
    transform: "matrix(0.97, -0.26, 0.26, 0.97, 16.9, 350.45)",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1328.31,
    y: 93.9,
    width: 22.29,
    height: 34.28,
    transform: "matrix(0.97, -0.26, 0.26, 0.97, 16.9, 350.45)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1325.8,
    y: 100.22,
    width: 17.03,
    height: 3.57,
    transform: "translate(19.06 348.82) rotate(-15)",
    style: {
      fill: "#2f497e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1325.8,
    y: 100.22,
    width: 17.03,
    height: 3.57,
    transform: "translate(19.06 348.82) rotate(-15)",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "952.54 154.8 944.35 154.8 944.35 146.6 937.6 146.6 937.6 154.8 929.4 154.8 929.4 161.55 937.6 161.55 937.6 169.74 944.35 169.74 944.35 161.55 952.54 161.55 952.54 154.8",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "952.54 154.8 944.35 154.8 944.35 146.6 937.6 146.6 937.6 154.8 929.4 154.8 929.4 161.55 937.6 161.55 937.6 169.74 944.35 169.74 944.35 161.55 952.54 161.55 952.54 154.8",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1233.69 210.42 1225.5 210.42 1225.5 202.22 1218.75 202.22 1218.75 210.42 1210.55 210.42 1210.55 217.17 1218.75 217.17 1218.75 225.36 1225.5 225.36 1225.5 217.17 1233.69 217.17 1233.69 210.42",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1233.69 210.42 1225.5 210.42 1225.5 202.22 1218.75 202.22 1218.75 210.42 1210.55 210.42 1210.55 217.17 1218.75 217.17 1218.75 225.36 1225.5 225.36 1225.5 217.17 1233.69 217.17 1233.69 210.42",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002,193.09a9.37,9.37,0,1,0-9.36,9.36A9.36,9.36,0,0,0,1002,193.09Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002,193.09a9.37,9.37,0,1,0-9.36,9.36A9.36,9.36,0,0,0,1002,193.09Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 999.56,
    y1: 193.09,
    x2: 985.65,
    y2: 193.09,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040.5,
    cy: 55.62,
    r: 9.36,
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1040.5,
    cy: 55.62,
    r: 9.36,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1045.42,
    y1: 60.53,
    x2: 1035.59,
    y2: 50.7,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.36,298.14a9.36,9.36,0,1,0-13.24,0A9.36,9.36,0,0,0,1353.36,298.14Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.36,298.14a9.36,9.36,0,1,0-13.24,0A9.36,9.36,0,0,0,1353.36,298.14Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1351.66,
    y1: 296.44,
    x2: 1341.83,
    y2: 286.6,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1065.69,
    cy: 260.88,
    rx: 14.98,
    ry: 6.42,
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1065.69,
    cy: 260.88,
    rx: 14.98,
    ry: 6.42,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1065.69,
    y1: 257.26,
    x2: 1065.69,
    y2: 264.84,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.05,234c-5.85-5.85-12.62-8.56-15.13-6.06s.21,9.28,6.06,15.13,12.62,8.56,15.13,6.06S1200.9,239.81,1195.05,234Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.05,234c-5.85-5.85-12.62-8.56-15.13-6.06s.21,9.28,6.06,15.13,12.62,8.56,15.13,6.06S1200.9,239.81,1195.05,234Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1193.07,
    y1: 235.94,
    x2: 1187.71,
    y2: 241.3,
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.72,79.73l9.48,9.48a3.46,3.46,0,0,0,4.88,0h0a3.45,3.45,0,0,0,0-4.88l-9.48-9.48a3.45,3.45,0,0,0-4.88,0h0A3.45,3.45,0,0,0,1265.72,79.73Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.72,79.73l9.48,9.48a3.46,3.46,0,0,0,4.88,0h0a3.45,3.45,0,0,0,0-4.88l-9.48-9.48a3.45,3.45,0,0,0-4.88,0h0A3.45,3.45,0,0,0,1265.72,79.73Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.72,79.73l4.83,4.83,4.88-4.88-4.83-4.83a3.45,3.45,0,0,0-4.88,0h0A3.45,3.45,0,0,0,1265.72,79.73Z",
    style: {
      fill: "#32cc98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.72,79.73l4.83,4.83,4.88-4.88-4.83-4.83a3.45,3.45,0,0,0-4.88,0h0A3.45,3.45,0,0,0,1265.72,79.73Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073,71.48V84.89a3.45,3.45,0,0,0,3.45,3.45h0a3.46,3.46,0,0,0,3.45-3.45V71.48a3.45,3.45,0,0,0-3.45-3.45h0A3.44,3.44,0,0,0,1073,71.48Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073,71.48V84.89a3.45,3.45,0,0,0,3.45,3.45h0a3.46,3.46,0,0,0,3.45-3.45V71.48a3.45,3.45,0,0,0-3.45-3.45h0A3.44,3.44,0,0,0,1073,71.48Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073,71.48v6.83h6.9V71.48a3.45,3.45,0,0,0-3.45-3.45h0A3.44,3.44,0,0,0,1073,71.48Z",
    style: {
      fill: "#32cc98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073,71.48v6.83h6.9V71.48a3.45,3.45,0,0,0-3.45-3.45h0A3.44,3.44,0,0,0,1073,71.48Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.39,236l9.48,9.48a3.46,3.46,0,0,0,4.88,0h0a3.45,3.45,0,0,0,0-4.88l-9.48-9.48a3.45,3.45,0,0,0-4.88,0h0A3.46,3.46,0,0,0,893.39,236Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.39,236l9.48,9.48a3.46,3.46,0,0,0,4.88,0h0a3.45,3.45,0,0,0,0-4.88l-9.48-9.48a3.45,3.45,0,0,0-4.88,0h0A3.46,3.46,0,0,0,893.39,236Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.39,236l4.84,4.83,4.88-4.88-4.84-4.83a3.45,3.45,0,0,0-4.88,0h0A3.46,3.46,0,0,0,893.39,236Z",
    style: {
      fill: "#32cc98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.39,236l4.84,4.83,4.88-4.88-4.84-4.83a3.45,3.45,0,0,0-4.88,0h0A3.46,3.46,0,0,0,893.39,236Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.21,204.84h13.41a3.46,3.46,0,0,0,3.45-3.45h0a3.45,3.45,0,0,0-3.45-3.45h-13.41a3.45,3.45,0,0,0-3.45,3.45h0A3.46,3.46,0,0,0,1142.21,204.84Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.21,204.84h13.41a3.46,3.46,0,0,0,3.45-3.45h0a3.45,3.45,0,0,0-3.45-3.45h-13.41a3.45,3.45,0,0,0-3.45,3.45h0A3.46,3.46,0,0,0,1142.21,204.84Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.21,204.84h6.84v-6.9h-6.84a3.45,3.45,0,0,0-3.45,3.45h0A3.46,3.46,0,0,0,1142.21,204.84Z",
    style: {
      fill: "#f16880"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.21,204.84h6.84v-6.9h-6.84a3.45,3.45,0,0,0-3.45,3.45h0A3.46,3.46,0,0,0,1142.21,204.84Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.52,305.17V291.76a3.46,3.46,0,0,0-3.46-3.45h0a3.46,3.46,0,0,0-3.45,3.45v13.41a3.45,3.45,0,0,0,3.45,3.45h0A3.45,3.45,0,0,0,1190.52,305.17Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.52,305.17V291.76a3.46,3.46,0,0,0-3.46-3.45h0a3.46,3.46,0,0,0-3.45,3.45v13.41a3.45,3.45,0,0,0,3.45,3.45h0A3.45,3.45,0,0,0,1190.52,305.17Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.52,305.17v-6.84h-6.91v6.84a3.45,3.45,0,0,0,3.45,3.45h0A3.45,3.45,0,0,0,1190.52,305.17Z",
    style: {
      fill: "#f16880"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.52,305.17v-6.84h-6.91v6.84a3.45,3.45,0,0,0,3.45,3.45h0A3.45,3.45,0,0,0,1190.52,305.17Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933,311.23v13.41a3.44,3.44,0,0,0,3.45,3.45h0a3.45,3.45,0,0,0,3.45-3.45V311.23a3.46,3.46,0,0,0-3.45-3.45h0A3.45,3.45,0,0,0,933,311.23Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933,311.23v13.41a3.44,3.44,0,0,0,3.45,3.45h0a3.45,3.45,0,0,0,3.45-3.45V311.23a3.46,3.46,0,0,0-3.45-3.45h0A3.45,3.45,0,0,0,933,311.23Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933,311.23v6.84h6.9v-6.84a3.46,3.46,0,0,0-3.45-3.45h0A3.45,3.45,0,0,0,933,311.23Z",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933,311.23v6.84h6.9v-6.84a3.46,3.46,0,0,0-3.45-3.45h0A3.45,3.45,0,0,0,933,311.23Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.89,126.06l-9.49-9.48a3.43,3.43,0,0,0-4.87,0h0a3.45,3.45,0,0,0,0,4.88l9.48,9.48a3.45,3.45,0,0,0,4.88,0h0A3.46,3.46,0,0,0,988.89,126.06Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.89,126.06l-9.49-9.48a3.43,3.43,0,0,0-4.87,0h0a3.45,3.45,0,0,0,0,4.88l9.48,9.48a3.45,3.45,0,0,0,4.88,0h0A3.46,3.46,0,0,0,988.89,126.06Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.89,126.06l-4.84-4.83-4.88,4.88,4.84,4.83a3.45,3.45,0,0,0,4.88,0h0A3.46,3.46,0,0,0,988.89,126.06Z",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.89,126.06l-4.84-4.83-4.88,4.88,4.84,4.83a3.45,3.45,0,0,0,4.88,0h0A3.46,3.46,0,0,0,988.89,126.06Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.88,147.59l9.48-9.48a3.45,3.45,0,0,0,0-4.88h0a3.45,3.45,0,0,0-4.88,0l-9.48,9.48a3.45,3.45,0,0,0,0,4.88h0A3.46,3.46,0,0,0,1261.88,147.59Z",
    style: {
      fill: "#f9fbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.88,147.59l9.48-9.48a3.45,3.45,0,0,0,0-4.88h0a3.45,3.45,0,0,0-4.88,0l-9.48,9.48a3.45,3.45,0,0,0,0,4.88h0A3.46,3.46,0,0,0,1261.88,147.59Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.88,147.59l4.84-4.84-4.88-4.88-4.84,4.84a3.45,3.45,0,0,0,0,4.88h0A3.46,3.46,0,0,0,1261.88,147.59Z",
    style: {
      fill: "#8aacdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.88,147.59l4.84-4.84-4.88-4.88-4.84,4.84a3.45,3.45,0,0,0,0,4.88h0A3.46,3.46,0,0,0,1261.88,147.59Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.13,121.46h13.41A3.46,3.46,0,0,0,1285,118h0a3.45,3.45,0,0,0-3.45-3.45h-13.41a3.44,3.44,0,0,0-3.45,3.45h0A3.45,3.45,0,0,0,1268.13,121.46Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.13,121.46H1275v-6.9h-6.83a3.44,3.44,0,0,0-3.45,3.45h0A3.45,3.45,0,0,0,1268.13,121.46Z",
    style: {
      fill: "none",
      stroke: "#2f497e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.34,164.49l.35.3a3.56,3.56,0,0,0-.83,2.16v1.12h-.5V167A3.65,3.65,0,0,1,186.34,164.49Zm1.72,0,.34.3a3.54,3.54,0,0,0-.82,2.16v1.12h-.5V167A3.61,3.61,0,0,1,188.06,164.49Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.47,178.39h6.92v.5H191V165.4h.51Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.74,173.68a5.88,5.88,0,0,1,.55-2.58,4.24,4.24,0,0,1,1.56-1.78,4.09,4.09,0,0,1,2.27-.64,4.21,4.21,0,0,1,2.26.62,4.12,4.12,0,0,1,1.56,1.76,5.82,5.82,0,0,1,.58,2.57v.44a6,6,0,0,1-.55,2.59,4.27,4.27,0,0,1-1.55,1.78,4.13,4.13,0,0,1-2.28.64,4.14,4.14,0,0,1-3.84-2.4,5.75,5.75,0,0,1-.56-2.55Zm.5.39a5.3,5.3,0,0,0,.49,2.3,3.92,3.92,0,0,0,1.38,1.62,3.63,3.63,0,0,0,2,.59,3.47,3.47,0,0,0,2.79-1.29A5,5,0,0,0,208,174v-.29a5.14,5.14,0,0,0-.5-2.28,4,4,0,0,0-1.38-1.63,3.57,3.57,0,0,0-2-.59,3.46,3.46,0,0,0-2.8,1.31,5,5,0,0,0-1.08,3.29Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.36,169.23l-.64,0a3,3,0,0,0-2.15.83,4.14,4.14,0,0,0-1.13,2.32v6.56h-.5v-10h.5V171a3.72,3.72,0,0,1,1.23-1.66,3.29,3.29,0,0,1,2.05-.61,2,2,0,0,1,.7.1Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.72,179.08a4,4,0,0,1-2.23-.66,4.54,4.54,0,0,1-1.59-1.79,5.57,5.57,0,0,1-.57-2.53v-.42a5.87,5.87,0,0,1,.55-2.55,4.52,4.52,0,0,1,1.53-1.8,3.71,3.71,0,0,1,2.13-.65,3.53,3.53,0,0,1,2.74,1.19,4.57,4.57,0,0,1,1.07,3.15v.52h-7.52v.55a5.06,5.06,0,0,0,.51,2.26,4.14,4.14,0,0,0,1.42,1.64,3.55,3.55,0,0,0,2,.59,3.88,3.88,0,0,0,1.72-.34,3.59,3.59,0,0,0,1.26-1l.35.25A3.79,3.79,0,0,1,220.72,179.08Zm-.18-9.9a3.27,3.27,0,0,0-2.49,1.09,4.57,4.57,0,0,0-1.19,2.77h7v-.12a4.17,4.17,0,0,0-.44-1.89,3.21,3.21,0,0,0-1.18-1.36A3,3,0,0,0,220.54,169.18Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.86,178.89h-.51v-6.73a3.26,3.26,0,0,0-.66-2.24,2.61,2.61,0,0,0-2.08-.74,3.19,3.19,0,0,0-2.7,1.45,5,5,0,0,0-.82,1.93v6.33h-.51v-10h.51v2.38a4.18,4.18,0,0,1,1.45-1.89,3.86,3.86,0,0,1,4.16-.12,2.72,2.72,0,0,1,1.05,1.82,3.7,3.7,0,0,1,1.45-1.73,4,4,0,0,1,2.24-.64,3,3,0,0,1,2.42.92,4.14,4.14,0,0,1,.8,2.75v6.54h-.5v-6.5a3.76,3.76,0,0,0-.66-2.44,2.54,2.54,0,0,0-2.09-.77,3.5,3.5,0,0,0-2.89,1.45,3.07,3.07,0,0,0-.66,1.6Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.1,165.73a.49.49,0,0,1,.15-.36.46.46,0,0,1,.36-.16.49.49,0,0,1,.37.16.51.51,0,0,1,0,.72.51.51,0,0,1-.37.15.51.51,0,0,1-.51-.51Zm.76,13.16h-.5v-10h.5Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.82,174a6.22,6.22,0,0,1-1,3.73,3.24,3.24,0,0,1-2.76,1.38,4.34,4.34,0,0,1-2-.47,3.44,3.44,0,0,1-1.39-1.28v5.42h-.5V168.86h.5v1.79a3.79,3.79,0,0,1,1.4-1.46,4,4,0,0,1,2-.51,3.28,3.28,0,0,1,2.77,1.35,6.22,6.22,0,0,1,1,3.78Zm-.51-.19a5.81,5.81,0,0,0-.86-3.38,2.75,2.75,0,0,0-2.41-1.22,3.53,3.53,0,0,0-2.14.65,3.67,3.67,0,0,0-1.27,1.88v4.69a3.21,3.21,0,0,0,1.28,1.61,3.9,3.9,0,0,0,2.15.57,2.73,2.73,0,0,0,2.39-1.23A6.19,6.19,0,0,0,259.31,173.78Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.72,176.44c0-1.22-1-2.05-3.11-2.49a6,6,0,0,1-2.61-1,2.17,2.17,0,0,1-.73-1.72,2.2,2.2,0,0,1,.93-1.82,3.94,3.94,0,0,1,2.43-.71,4.1,4.1,0,0,1,2.6.77,2.52,2.52,0,0,1,1,2.09h-.5a2.07,2.07,0,0,0-.86-1.68,4,4,0,0,0-4.31-.11,1.76,1.76,0,0,0-.77,1.44,1.73,1.73,0,0,0,.29,1.06,2.42,2.42,0,0,0,.94.7,10,10,0,0,0,1.89.59,8.3,8.3,0,0,1,2,.68,2.75,2.75,0,0,1,1,.92,2.45,2.45,0,0,1,.32,1.31,2.27,2.27,0,0,1-1,1.91,4.19,4.19,0,0,1-2.55.72,4.47,4.47,0,0,1-2.72-.77,2.34,2.34,0,0,1-1-2h.5a2.07,2.07,0,0,0,.93,1.65,4.07,4.07,0,0,0,2.32.59,3.51,3.51,0,0,0,2.18-.63A1.83,1.83,0,0,0,268.72,176.44Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.71,178.89v-1.62a3.24,3.24,0,0,1-1.3,1.32,4.26,4.26,0,0,1-2.16.49,3.05,3.05,0,0,1-2.46-1,4.23,4.23,0,0,1-.84-2.8v-6.46h.5v6.48a3.68,3.68,0,0,0,.72,2.42,2.59,2.59,0,0,0,2.06.82,3.8,3.8,0,0,0,2.34-.68,3,3,0,0,0,1.14-2v-7.06h.51v10Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.55,178.89h-.5v-6.73a3.36,3.36,0,0,0-.66-2.24,2.62,2.62,0,0,0-2.08-.74,3.19,3.19,0,0,0-2.7,1.45,5,5,0,0,0-.83,1.93v6.33h-.51v-10h.51v2.38a4.2,4.2,0,0,1,1.46-1.89,3.52,3.52,0,0,1,2.09-.67,3.58,3.58,0,0,1,2.07.55,2.8,2.8,0,0,1,1.05,1.82,3.74,3.74,0,0,1,1.44-1.73,4.07,4.07,0,0,1,2.25-.64,3,3,0,0,1,2.41.92,4.08,4.08,0,0,1,.8,2.75v6.54h-.5v-6.5a3.76,3.76,0,0,0-.66-2.44,2.51,2.51,0,0,0-2.08-.77,3.49,3.49,0,0,0-2.89,1.45,3.09,3.09,0,0,0-.67,1.6Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.47,173.78a6.17,6.17,0,0,1,1-3.75,3.28,3.28,0,0,1,2.77-1.35,3.86,3.86,0,0,1,2,.51,3.69,3.69,0,0,1,1.4,1.52v-6.05h.51v14.23h-.51v-1.6a3.46,3.46,0,0,1-1.39,1.32,4.34,4.34,0,0,1-2,.47,3.24,3.24,0,0,1-2.75-1.38,6.34,6.34,0,0,1-1-3.79Zm.52.19a5.92,5.92,0,0,0,.84,3.37,2.73,2.73,0,0,0,2.4,1.24,4,4,0,0,0,2.12-.55,3.25,3.25,0,0,0,1.3-1.62v-4.7a3.34,3.34,0,0,0-3.41-2.53,2.76,2.76,0,0,0-2.39,1.21A6.22,6.22,0,0,0,304,174Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.56,173.68a5.88,5.88,0,0,1,.56-2.58,4.13,4.13,0,0,1,3.83-2.42,4.24,4.24,0,0,1,2.26.62,4.12,4.12,0,0,1,1.56,1.76,5.68,5.68,0,0,1,.57,2.57v.44a6,6,0,0,1-.54,2.59,4.3,4.3,0,0,1-1.56,1.78,4.12,4.12,0,0,1-2.27.64,4.14,4.14,0,0,1-3.84-2.4,5.9,5.9,0,0,1-.57-2.55Zm.51.39a5.3,5.3,0,0,0,.49,2.3,3.92,3.92,0,0,0,1.38,1.62,3.61,3.61,0,0,0,2,.59,3.47,3.47,0,0,0,2.79-1.29,5,5,0,0,0,1.08-3.32v-.29a5.14,5.14,0,0,0-.5-2.28,4,4,0,0,0-1.38-1.63,3.57,3.57,0,0,0-2-.59,3.45,3.45,0,0,0-2.8,1.31,5,5,0,0,0-1.08,3.29Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.39,178.89h-.5V164.66h.5Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.92,173.68a6,6,0,0,1,.55-2.58,4.24,4.24,0,0,1,1.56-1.78,4.13,4.13,0,0,1,2.28-.64,4.24,4.24,0,0,1,2.26.62,4.12,4.12,0,0,1,1.56,1.76,6,6,0,0,1,.57,2.57v.44a5.83,5.83,0,0,1-.55,2.59,4.21,4.21,0,0,1-1.55,1.78,4.12,4.12,0,0,1-2.27.64,4.14,4.14,0,0,1-3.84-2.4,5.9,5.9,0,0,1-.57-2.55Zm.5.39a5.31,5.31,0,0,0,.5,2.3A3.92,3.92,0,0,0,330.3,178a3.59,3.59,0,0,0,2,.59,3.47,3.47,0,0,0,2.79-1.29A5,5,0,0,0,336.2,174v-.29a5.28,5.28,0,0,0-.5-2.28,4,4,0,0,0-1.39-1.63,3.56,3.56,0,0,0-2-.59,3.44,3.44,0,0,0-2.8,1.31,4.93,4.93,0,0,0-1.09,3.29Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,169.23l-.65,0a3,3,0,0,0-2.14.83,4.14,4.14,0,0,0-1.13,2.32v6.56h-.5v-10h.5V171a3.7,3.7,0,0,1,1.22-1.66,3.33,3.33,0,0,1,2-.61,1.92,1.92,0,0,1,.7.1Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2,176.44c0-1.22-1-2.05-3.11-2.49a6,6,0,0,1-2.61-1,2.14,2.14,0,0,1-.73-1.72,2.2,2.2,0,0,1,.93-1.82,3.92,3.92,0,0,1,2.43-.71,4.1,4.1,0,0,1,2.6.77,2.55,2.55,0,0,1,1,2.09h-.51a2.06,2.06,0,0,0-.85-1.68,4,4,0,0,0-4.31-.11,1.76,1.76,0,0,0-.77,1.44,1.73,1.73,0,0,0,.29,1.06,2.46,2.46,0,0,0,.93.7,10.36,10.36,0,0,0,1.9.59,8.46,8.46,0,0,1,2,.68,2.75,2.75,0,0,1,1.05.92,2.54,2.54,0,0,1,.32,1.31,2.27,2.27,0,0,1-1,1.91,4.19,4.19,0,0,1-2.55.72,4.47,4.47,0,0,1-2.72-.77,2.34,2.34,0,0,1-1-2h.5a2.07,2.07,0,0,0,.93,1.65,4,4,0,0,0,2.32.59,3.53,3.53,0,0,0,2.18-.63A1.83,1.83,0,0,0,356.2,176.44Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.32,165.73a.49.49,0,0,1,.15-.36.46.46,0,0,1,.36-.16.47.47,0,0,1,.37.16.51.51,0,0,1,0,.72.5.5,0,0,1-.37.15.51.51,0,0,1-.51-.51Zm.76,13.16h-.5v-10h.5Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.5,166.16v2.7h2.28v.5H364.5v7.13a2.87,2.87,0,0,0,.34,1.58,1.32,1.32,0,0,0,1.17.51,6.69,6.69,0,0,0,1-.09l.08.48a3.51,3.51,0,0,1-1,.11,1.85,1.85,0,0,1-1.57-.61,3.08,3.08,0,0,1-.48-1.92v-7.19h-1.86v-.5H364v-2.7Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.4,178.89a7.12,7.12,0,0,1-.18-1.83,4,4,0,0,1-1.63,1.49,5,5,0,0,1-2.32.53,3.2,3.2,0,0,1-2.24-.76,2.49,2.49,0,0,1-.85-2,2.56,2.56,0,0,1,1.25-2.21,6.07,6.07,0,0,1,3.31-.85h2.48v-1.46a2.48,2.48,0,0,0-.8-2,3.32,3.32,0,0,0-2.26-.69,3.63,3.63,0,0,0-2.29.7,2.13,2.13,0,0,0-.92,1.75l-.5,0a2.58,2.58,0,0,1,1.07-2.08,4.12,4.12,0,0,1,2.64-.85,3.82,3.82,0,0,1,2.57.81,2.9,2.9,0,0,1,1,2.28v4.8a6.26,6.26,0,0,0,.26,2.24v.08Zm-4.13-.31a4.5,4.5,0,0,0,2.42-.63,3.89,3.89,0,0,0,1.53-1.77v-2.39H377.9a5.4,5.4,0,0,0-3.29.86,2.08,2.08,0,0,0-.93,1.73,2,2,0,0,0,.73,1.56A2.76,2.76,0,0,0,376.27,178.58Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.12,178.89h-.5v-6.73a3.31,3.31,0,0,0-.67-2.24,2.61,2.61,0,0,0-2.08-.74,3.19,3.19,0,0,0-2.7,1.45,5,5,0,0,0-.82,1.93v6.33h-.51v-10h.51v2.38a4.18,4.18,0,0,1,1.45-1.89,3.86,3.86,0,0,1,4.16-.12,2.72,2.72,0,0,1,1.05,1.82,3.7,3.7,0,0,1,1.45-1.73,4,4,0,0,1,2.24-.64,3,3,0,0,1,2.42.92,4.14,4.14,0,0,1,.8,2.75v6.54h-.5v-6.5a3.76,3.76,0,0,0-.66-2.44,2.54,2.54,0,0,0-2.09-.77,3.5,3.5,0,0,0-2.89,1.45,3.07,3.07,0,0,0-.66,1.6Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.56,179.08a4,4,0,0,1-2.22-.66,4.39,4.39,0,0,1-1.59-1.79,5.45,5.45,0,0,1-.58-2.53v-.42a5.88,5.88,0,0,1,.56-2.55,4.37,4.37,0,0,1,1.53-1.8,3.68,3.68,0,0,1,2.12-.65,3.52,3.52,0,0,1,2.74,1.19,4.57,4.57,0,0,1,1.07,3.15v.52h-7.52v.55a4.94,4.94,0,0,0,.52,2.26A4,4,0,0,0,402.6,178a3.57,3.57,0,0,0,2,.59,3.88,3.88,0,0,0,1.72-.34,3.42,3.42,0,0,0,1.26-1l.35.25A3.78,3.78,0,0,1,404.56,179.08Zm-.18-9.9a3.23,3.23,0,0,0-2.48,1.09,4.64,4.64,0,0,0-1.2,2.77h7v-.12a4.3,4.3,0,0,0-.43-1.89,3.3,3.3,0,0,0-1.19-1.36A3,3,0,0,0,404.38,169.18Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.65,166.16v2.7h2.28v.5h-2.28v7.13a2.87,2.87,0,0,0,.34,1.58,1.32,1.32,0,0,0,1.17.51,6.69,6.69,0,0,0,1-.09l.08.48a3.55,3.55,0,0,1-1.05.11,1.84,1.84,0,0,1-1.56-.61,3.08,3.08,0,0,1-.48-1.92v-7.19h-1.86v-.5h1.86v-2.7Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.13,181.26l-.34-.3a3.56,3.56,0,0,0,.81-2v-1.55h.5v1.35A3.65,3.65,0,0,1,416.13,181.26Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,178.58a3.4,3.4,0,0,0,2.25-.73,2.68,2.68,0,0,0,1-2h.5a3.13,3.13,0,0,1-1.12,2.34,3.89,3.89,0,0,1-2.6.89,3.65,3.65,0,0,1-3-1.36,5.71,5.71,0,0,1-1.11-3.7v-.34A5.59,5.59,0,0,1,425,170a3.6,3.6,0,0,1,3-1.36,3.76,3.76,0,0,1,2.63.95,3.5,3.5,0,0,1,1.1,2.54h-.5a3,3,0,0,0-.95-2.17,3.21,3.21,0,0,0-2.28-.82,3.14,3.14,0,0,0-2.63,1.21,5.29,5.29,0,0,0-.95,3.36v.32a5.16,5.16,0,0,0,1,3.31A3.19,3.19,0,0,0,428,178.58Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.49,173.68a6,6,0,0,1,.55-2.58,4.24,4.24,0,0,1,1.56-1.78,4.13,4.13,0,0,1,2.28-.64,4.24,4.24,0,0,1,2.26.62,4.12,4.12,0,0,1,1.56,1.76,6,6,0,0,1,.57,2.57v.44a5.83,5.83,0,0,1-.55,2.59,4.21,4.21,0,0,1-1.55,1.78,4.13,4.13,0,0,1-2.28.64,4.14,4.14,0,0,1-3.83-2.4,5.9,5.9,0,0,1-.57-2.55Zm.5.39a5.31,5.31,0,0,0,.5,2.3,3.92,3.92,0,0,0,1.38,1.62,3.58,3.58,0,0,0,2,.59,3.48,3.48,0,0,0,2.8-1.29,5,5,0,0,0,1.08-3.32v-.29a5.28,5.28,0,0,0-.5-2.28,4,4,0,0,0-1.39-1.63,3.56,3.56,0,0,0-2-.59,3.44,3.44,0,0,0-2.8,1.31,4.93,4.93,0,0,0-1.09,3.29Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.2,171.2a4.17,4.17,0,0,1,1.45-1.84,3.5,3.5,0,0,1,2.11-.68,3,3,0,0,1,2.39.91,4.17,4.17,0,0,1,.8,2.76v6.54h-.5v-6.55a3.74,3.74,0,0,0-.66-2.39,2.56,2.56,0,0,0-2.06-.77,3.16,3.16,0,0,0-2.25.92,4.67,4.67,0,0,0-1.28,2.38v6.41h-.5v-10h.5Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.27,176.44c0-1.22-1-2.05-3.11-2.49a6,6,0,0,1-2.61-1,2.14,2.14,0,0,1-.73-1.72,2.2,2.2,0,0,1,.93-1.82,3.92,3.92,0,0,1,2.43-.71,4.12,4.12,0,0,1,2.6.77,2.52,2.52,0,0,1,1,2.09h-.51a2.06,2.06,0,0,0-.85-1.68,4,4,0,0,0-4.31-.11,1.76,1.76,0,0,0-.77,1.44,1.73,1.73,0,0,0,.29,1.06,2.46,2.46,0,0,0,.93.7,10.36,10.36,0,0,0,1.9.59,8.46,8.46,0,0,1,2,.68,2.75,2.75,0,0,1,1.05.92,2.54,2.54,0,0,1,.32,1.31,2.27,2.27,0,0,1-1,1.91,4.19,4.19,0,0,1-2.55.72,4.45,4.45,0,0,1-2.72-.77,2.34,2.34,0,0,1-1-2h.5a2.07,2.07,0,0,0,.93,1.65,4,4,0,0,0,2.32.59,3.53,3.53,0,0,0,2.18-.63A1.83,1.83,0,0,0,461.27,176.44Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.14,179.08a4,4,0,0,1-2.23-.66,4.39,4.39,0,0,1-1.59-1.79,5.57,5.57,0,0,1-.57-2.53v-.42a5.87,5.87,0,0,1,.55-2.55,4.37,4.37,0,0,1,1.53-1.8,3.7,3.7,0,0,1,2.12-.65,3.54,3.54,0,0,1,2.75,1.19,4.57,4.57,0,0,1,1.06,3.15v.52h-7.51v.55a5.06,5.06,0,0,0,.51,2.26,4.06,4.06,0,0,0,1.42,1.64,3.52,3.52,0,0,0,2,.59,3.91,3.91,0,0,0,1.72-.34,3.47,3.47,0,0,0,1.25-1l.36.25A3.79,3.79,0,0,1,468.14,179.08Zm-.19-9.9a3.26,3.26,0,0,0-2.48,1.09,4.64,4.64,0,0,0-1.2,2.77h7v-.12a4.16,4.16,0,0,0-.43-1.89,3.28,3.28,0,0,0-1.18-1.36A3,3,0,0,0,468,169.18Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.5,178.58a3.4,3.4,0,0,0,2.25-.73,2.68,2.68,0,0,0,1-2h.5a3.16,3.16,0,0,1-1.12,2.34,3.91,3.91,0,0,1-2.6.89,3.68,3.68,0,0,1-3-1.36,5.71,5.71,0,0,1-1.11-3.7v-.34a5.59,5.59,0,0,1,1.11-3.64,3.63,3.63,0,0,1,3-1.36,3.76,3.76,0,0,1,2.63.95,3.51,3.51,0,0,1,1.11,2.54h-.5a3.06,3.06,0,0,0-1-2.17,3.22,3.22,0,0,0-2.29-.82,3.16,3.16,0,0,0-2.63,1.21,5.35,5.35,0,0,0-1,3.36v.32a5.16,5.16,0,0,0,1,3.31A3.2,3.2,0,0,0,477.5,178.58Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.85,166.16v2.7h2.28v.5h-2.28v7.13a2.87,2.87,0,0,0,.35,1.58,1.3,1.3,0,0,0,1.16.51,6.69,6.69,0,0,0,1-.09l.09.48a3.64,3.64,0,0,1-1.05.11,1.86,1.86,0,0,1-1.57-.61,3.21,3.21,0,0,1-.48-1.92v-7.19h-1.85v-.5h1.85v-2.7Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.34,179.08a4,4,0,0,1-2.23-.66,4.39,4.39,0,0,1-1.59-1.79,5.57,5.57,0,0,1-.57-2.53v-.42a5.87,5.87,0,0,1,.55-2.55,4.37,4.37,0,0,1,1.53-1.8,3.71,3.71,0,0,1,2.13-.65,3.53,3.53,0,0,1,2.74,1.19A4.57,4.57,0,0,1,497,173v.52h-7.51v.55a5.06,5.06,0,0,0,.51,2.26,4.06,4.06,0,0,0,1.42,1.64,3.55,3.55,0,0,0,2,.59,3.91,3.91,0,0,0,1.72-.34,3.59,3.59,0,0,0,1.26-1l.35.25A3.79,3.79,0,0,1,493.34,179.08Zm-.18-9.9a3.27,3.27,0,0,0-2.49,1.09,4.57,4.57,0,0,0-1.19,2.77h7v-.12A4.16,4.16,0,0,0,496,171a3.21,3.21,0,0,0-1.18-1.36A3,3,0,0,0,493.16,169.18Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.63,173h-4.36v-.5h4.36Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.19,188.94v2.7h2.28v.5h-2.28v7.13a2.78,2.78,0,0,0,.35,1.58,1.29,1.29,0,0,0,1.16.51,6.69,6.69,0,0,0,1-.09l.08.48a3.51,3.51,0,0,1-1,.11,1.86,1.86,0,0,1-1.57-.61,3.1,3.1,0,0,1-.48-1.92v-7.19h-1.86v-.5h1.86v-2.7Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.79,201.67v-1.62a3.21,3.21,0,0,1-1.29,1.32,4.26,4.26,0,0,1-2.16.49,3.07,3.07,0,0,1-2.47-1,4.29,4.29,0,0,1-.83-2.8v-6.46h.5v6.48a3.7,3.7,0,0,0,.72,2.42,2.58,2.58,0,0,0,2.06.82,3.79,3.79,0,0,0,2.33-.68,3,3,0,0,0,1.14-2v-7.06h.51v10Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.07,201.86a4,4,0,0,1-2.23-.66,4.39,4.39,0,0,1-1.59-1.79,5.57,5.57,0,0,1-.58-2.53v-.42a5.88,5.88,0,0,1,.56-2.55,4.37,4.37,0,0,1,1.53-1.8,3.7,3.7,0,0,1,2.12-.65,3.54,3.54,0,0,1,2.75,1.19,4.57,4.57,0,0,1,1.06,3.15v.52h-7.51v.55a5.06,5.06,0,0,0,.51,2.26,4,4,0,0,0,1.42,1.63,3.46,3.46,0,0,0,2,.6,3.94,3.94,0,0,0,1.72-.34,3.47,3.47,0,0,0,1.25-1l.36.25A3.79,3.79,0,0,1,206.07,201.86Zm-.19-9.9a3.26,3.26,0,0,0-2.48,1.09,4.64,4.64,0,0,0-1.2,2.77h7v-.12a4.16,4.16,0,0,0-.43-1.89,3.23,3.23,0,0,0-1.19-1.36A3,3,0,0,0,205.88,192Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.45,192l-.65,0a2.93,2.93,0,0,0-2.14.83,4.08,4.08,0,0,0-1.13,2.32v6.56H212v-10h.5v2.09a3.7,3.7,0,0,1,1.22-1.66,3.33,3.33,0,0,1,2.05-.61,1.92,1.92,0,0,1,.7.1Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4,201.67a6.63,6.63,0,0,1-.19-1.83,4,4,0,0,1-1.62,1.49,5.06,5.06,0,0,1-2.33.53,3.19,3.19,0,0,1-2.23-.76,2.49,2.49,0,0,1-.85-2,2.53,2.53,0,0,1,1.24-2.21,6.1,6.1,0,0,1,3.32-.85h2.47v-1.46a2.48,2.48,0,0,0-.79-2,3.35,3.35,0,0,0-2.27-.69,3.67,3.67,0,0,0-2.29.7,2.12,2.12,0,0,0-.91,1.75l-.5,0a2.56,2.56,0,0,1,1.07-2.08,4.11,4.11,0,0,1,2.63-.85,3.87,3.87,0,0,1,2.58.81,2.9,2.9,0,0,1,1,2.28v4.8a6.5,6.5,0,0,0,.26,2.24v.08Zm-4.14-.31a4.53,4.53,0,0,0,2.43-.63,3.93,3.93,0,0,0,1.52-1.77v-2.39H226.9a5.43,5.43,0,0,0-3.3.86,2.1,2.1,0,0,0-.92,1.73,2,2,0,0,0,.73,1.56A2.75,2.75,0,0,0,225.26,201.36Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.48,196.56a6.1,6.1,0,0,1,1-3.75,3.26,3.26,0,0,1,2.77-1.35,3.83,3.83,0,0,1,2,.51,3.72,3.72,0,0,1,1.41,1.52v-6.05h.5v14.23h-.5v-1.6a3.49,3.49,0,0,1-1.4,1.32,4.3,4.3,0,0,1-2,.47,3.22,3.22,0,0,1-2.75-1.38,6.27,6.27,0,0,1-1-3.79Zm.51.19a5.94,5.94,0,0,0,.85,3.37,2.74,2.74,0,0,0,2.39,1.24,4,4,0,0,0,2.12-.55,3.32,3.32,0,0,0,1.31-1.62v-4.7a3.35,3.35,0,0,0-3.41-2.53,2.76,2.76,0,0,0-2.4,1.21A6.2,6.2,0,0,0,233,196.75Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.19,188.51a.53.53,0,0,1,.15-.37.49.49,0,0,1,.36-.15.51.51,0,0,1,.52.52.49.49,0,0,1-.15.36.53.53,0,0,1-.37.15.51.51,0,0,1-.51-.51Zm.76,13.16h-.5v-10h.5Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.9,196.75a6.16,6.16,0,0,1-1,3.73,3.22,3.22,0,0,1-2.75,1.38,4.34,4.34,0,0,1-2-.47,3.51,3.51,0,0,1-1.39-1.28v5.42h-.5V191.64h.5v1.79a3.72,3.72,0,0,1,1.4-1.46,3.94,3.94,0,0,1,2-.51,3.26,3.26,0,0,1,2.77,1.35,6.16,6.16,0,0,1,1,3.78Zm-.5-.19a5.81,5.81,0,0,0-.86-3.38,2.77,2.77,0,0,0-2.41-1.22,3.53,3.53,0,0,0-2.14.65,3.61,3.61,0,0,0-1.27,1.88v4.69a3.21,3.21,0,0,0,1.28,1.61,3.87,3.87,0,0,0,2.15.57,2.74,2.74,0,0,0,2.39-1.23A6.21,6.21,0,0,0,254.4,196.56Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.49,188.51a.53.53,0,0,1,.15-.37A.49.49,0,0,1,258,188a.51.51,0,0,1,.52.52.49.49,0,0,1-.15.36.53.53,0,0,1-.37.15.51.51,0,0,1-.51-.51Zm.76,13.16h-.5v-10h.5Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.72,199.22c0-1.22-1-2.05-3.11-2.49a6.18,6.18,0,0,1-2.61-1,2.17,2.17,0,0,1-.73-1.72,2.2,2.2,0,0,1,.93-1.82,3.94,3.94,0,0,1,2.43-.71,4.1,4.1,0,0,1,2.6.77,2.51,2.51,0,0,1,1,2.09h-.5a2.1,2.1,0,0,0-.86-1.69,4.06,4.06,0,0,0-4.31-.1,1.85,1.85,0,0,0-.48,2.5,2.42,2.42,0,0,0,.94.7,10,10,0,0,0,1.89.59,8.3,8.3,0,0,1,2,.68,2.75,2.75,0,0,1,1,.92,2.44,2.44,0,0,1,.32,1.3,2.25,2.25,0,0,1-1,1.91,4.13,4.13,0,0,1-2.55.73,4.47,4.47,0,0,1-2.72-.77,2.34,2.34,0,0,1-1-2h.5a2.07,2.07,0,0,0,.93,1.65,4.07,4.07,0,0,0,2.32.59,3.51,3.51,0,0,0,2.18-.63A1.84,1.84,0,0,0,267.72,199.22Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.39,201.36a3.4,3.4,0,0,0,2.25-.73,2.65,2.65,0,0,0,1-2h.5A3.1,3.1,0,0,1,277,201a3.88,3.88,0,0,1-2.59.89,3.67,3.67,0,0,1-3-1.36,5.71,5.71,0,0,1-1.11-3.7v-.34a5.59,5.59,0,0,1,1.11-3.64,3.63,3.63,0,0,1,3-1.36,3.76,3.76,0,0,1,2.63.95,3.5,3.5,0,0,1,1.1,2.54h-.5a3,3,0,0,0-1-2.17,3.21,3.21,0,0,0-2.28-.82,3.16,3.16,0,0,0-2.63,1.21,5.31,5.31,0,0,0-.95,3.36v.32a5.18,5.18,0,0,0,1,3.31A3.2,3.2,0,0,0,274.39,201.36Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.48,188.51a.53.53,0,0,1,.15-.37A.48.48,0,0,1,281,188a.49.49,0,0,1,.36.15.5.5,0,0,1,.16.37.46.46,0,0,1-.16.36.49.49,0,0,1-.36.15.48.48,0,0,1-.36-.15A.49.49,0,0,1,280.48,188.51Zm.76,13.16h-.5v-10h.5Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,194a4.31,4.31,0,0,1,1.44-1.85,3.58,3.58,0,0,1,2.12-.67,3,3,0,0,1,2.39.91,4.17,4.17,0,0,1,.8,2.76v6.54h-.5v-6.55a3.74,3.74,0,0,0-.66-2.39,2.57,2.57,0,0,0-2.06-.77,3.14,3.14,0,0,0-2.25.92,4.68,4.68,0,0,0-1.28,2.37v6.42h-.5v-10h.5Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.45,196.56a6.1,6.1,0,0,1,1-3.75,3.26,3.26,0,0,1,2.77-1.35,3.88,3.88,0,0,1,2,.51,3.79,3.79,0,0,1,1.4,1.51v-1.84h.51v9.86a4.44,4.44,0,0,1-1,3.1,3.57,3.57,0,0,1-2.77,1.11,3.94,3.94,0,0,1-1.85-.43,4,4,0,0,1-1.43-1.26l.35-.33a4.35,4.35,0,0,0,1.28,1.13,3.28,3.28,0,0,0,1.63.39,3.1,3.1,0,0,0,2.41-.94,3.9,3.9,0,0,0,.89-2.65v-1.53a3.49,3.49,0,0,1-1.41,1.31,4.33,4.33,0,0,1-2,.46,3.22,3.22,0,0,1-2.75-1.38,6.27,6.27,0,0,1-1-3.79Zm.51.19a5.85,5.85,0,0,0,.85,3.38,2.74,2.74,0,0,0,2.39,1.23,3.83,3.83,0,0,0,2.16-.59,3.2,3.2,0,0,0,1.26-1.66v-4.55a3.31,3.31,0,0,0-3.4-2.6,2.78,2.78,0,0,0-2.41,1.21A6.21,6.21,0,0,0,295,196.75Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.47,201.86a4,4,0,0,1-2.23-.66,4.54,4.54,0,0,1-1.59-1.79,5.57,5.57,0,0,1-.57-2.53v-.42a5.88,5.88,0,0,1,.56-2.55,4.37,4.37,0,0,1,1.53-1.8,3.66,3.66,0,0,1,2.12-.65,3.52,3.52,0,0,1,2.74,1.19,4.57,4.57,0,0,1,1.07,3.15v.52h-7.52v.55a4.94,4.94,0,0,0,.52,2.26,4,4,0,0,0,1.41,1.63,3.5,3.5,0,0,0,2,.6,3.88,3.88,0,0,0,1.72-.34,3.5,3.5,0,0,0,1.26-1l.35.25A3.79,3.79,0,0,1,313.47,201.86Zm-.18-9.9a3.27,3.27,0,0,0-2.49,1.09,4.63,4.63,0,0,0-1.19,2.77h7v-.12a4.3,4.3,0,0,0-.43-1.89,3.3,3.3,0,0,0-1.19-1.36A3,3,0,0,0,313.29,192Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.05,201.67h-.5V187.44h.5Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.21,188.51a.57.57,0,0,1,.14-.37.5.5,0,0,1,.37-.15.49.49,0,0,1,.36.15.53.53,0,0,1,.15.37.51.51,0,0,1-.51.51.5.5,0,0,1-.37-.15A.52.52,0,0,1,323.21,188.51Zm.76,13.16h-.5v-10h.5Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.38,188.94v2.7h2.28v.5h-2.28v7.13a2.78,2.78,0,0,0,.35,1.58,1.29,1.29,0,0,0,1.16.51,6.69,6.69,0,0,0,1-.09l.08.48a3.51,3.51,0,0,1-1,.11,1.86,1.86,0,0,1-1.57-.61,3.1,3.1,0,0,1-.48-1.92v-7.19H326v-.5h1.86v-2.7Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.86,204l-.34-.3a3.65,3.65,0,0,0,.82-2V200.2h.5v1.35A3.71,3.71,0,0,1,332.86,204Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.54,199.22q0-1.83-3.12-2.49a6.12,6.12,0,0,1-2.6-1,2.15,2.15,0,0,1-.74-1.72,2.21,2.21,0,0,1,.94-1.82,3.89,3.89,0,0,1,2.42-.71,4.1,4.1,0,0,1,2.6.77,2.52,2.52,0,0,1,1,2.09h-.51a2.1,2.1,0,0,0-.86-1.69,4.06,4.06,0,0,0-4.31-.1,1.74,1.74,0,0,0-.76,1.44,1.75,1.75,0,0,0,.28,1.06,2.5,2.5,0,0,0,.94.7,10,10,0,0,0,1.89.59,8.3,8.3,0,0,1,2,.68,2.61,2.61,0,0,1,1,.92,2.44,2.44,0,0,1,.33,1.3,2.26,2.26,0,0,1-1,1.91,4.13,4.13,0,0,1-2.55.73,4.47,4.47,0,0,1-2.72-.77,2.34,2.34,0,0,1-1-2h.5a2.07,2.07,0,0,0,.93,1.65,4.07,4.07,0,0,0,2.32.59,3.56,3.56,0,0,0,2.19-.63A1.84,1.84,0,0,0,347.54,199.22Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.4,201.86a4,4,0,0,1-2.23-.66,4.54,4.54,0,0,1-1.59-1.79,5.57,5.57,0,0,1-.57-2.53v-.42a5.88,5.88,0,0,1,.56-2.55,4.37,4.37,0,0,1,1.53-1.8,3.66,3.66,0,0,1,2.12-.65,3.52,3.52,0,0,1,2.74,1.19A4.57,4.57,0,0,1,358,195.8v.52h-7.52v.55a4.94,4.94,0,0,0,.52,2.26,4,4,0,0,0,1.41,1.63,3.5,3.5,0,0,0,2,.6,3.88,3.88,0,0,0,1.72-.34,3.5,3.5,0,0,0,1.26-1l.35.25A3.79,3.79,0,0,1,354.4,201.86Zm-.18-9.9a3.27,3.27,0,0,0-2.49,1.09,4.63,4.63,0,0,0-1.19,2.77h7v-.12a4.3,4.3,0,0,0-.43-1.89,3.3,3.3,0,0,0-1.19-1.36A3,3,0,0,0,354.22,192Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.9,196.56a6.17,6.17,0,0,1,1-3.75,3.27,3.27,0,0,1,2.77-1.35,3.86,3.86,0,0,1,2,.51,3.63,3.63,0,0,1,1.4,1.52v-6.05h.5v14.23h-.5v-1.6a3.43,3.43,0,0,1-1.4,1.32,4.27,4.27,0,0,1-2,.47,3.22,3.22,0,0,1-2.75-1.38,6.34,6.34,0,0,1-1-3.79Zm.52.19a5.94,5.94,0,0,0,.84,3.37,2.75,2.75,0,0,0,2.39,1.24,4,4,0,0,0,2.13-.55,3.3,3.3,0,0,0,1.3-1.62v-4.7a3.34,3.34,0,0,0-3.41-2.53,2.76,2.76,0,0,0-2.39,1.21A6.2,6.2,0,0,0,360.42,196.75Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.83,196.56a6.17,6.17,0,0,1,1-3.75,3.28,3.28,0,0,1,2.77-1.35,3.86,3.86,0,0,1,2,.51,3.72,3.72,0,0,1,1.41,1.52v-6.05h.5v14.23H382v-1.6a3.49,3.49,0,0,1-1.4,1.32,4.33,4.33,0,0,1-2,.47,3.24,3.24,0,0,1-2.76-1.38,6.34,6.34,0,0,1-1-3.79Zm.52.19a5.94,5.94,0,0,0,.84,3.37,2.75,2.75,0,0,0,2.4,1.24,4,4,0,0,0,2.12-.55,3.32,3.32,0,0,0,1.31-1.62v-4.7A3.36,3.36,0,0,0,378.6,192a2.76,2.76,0,0,0-2.39,1.21A6.2,6.2,0,0,0,375.35,196.75Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.55,188.51a.57.57,0,0,1,.14-.37.5.5,0,0,1,.37-.15.49.49,0,0,1,.36.15.54.54,0,0,1,.16.37.5.5,0,0,1-.16.36.49.49,0,0,1-.36.15.5.5,0,0,1-.37-.15A.52.52,0,0,1,385.55,188.51Zm.76,13.16h-.5v-10h.5Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.08,201.67a6.63,6.63,0,0,1-.19-1.83,4,4,0,0,1-1.62,1.49,5.06,5.06,0,0,1-2.33.53,3.24,3.24,0,0,1-2.24-.76,2.65,2.65,0,0,1,.4-4.18,6.1,6.1,0,0,1,3.32-.85h2.47v-1.46a2.48,2.48,0,0,0-.79-2,3.37,3.37,0,0,0-2.27-.69,3.65,3.65,0,0,0-2.29.7,2.13,2.13,0,0,0-.92,1.75l-.5,0a2.57,2.57,0,0,1,1.08-2.08,4.09,4.09,0,0,1,2.63-.85,3.87,3.87,0,0,1,2.58.81,2.93,2.93,0,0,1,1,2.28v4.8a6.5,6.5,0,0,0,.26,2.24v.08Zm-4.14-.31a4.53,4.53,0,0,0,2.43-.63,3.93,3.93,0,0,0,1.52-1.77v-2.39h-2.32a5.42,5.42,0,0,0-3.29.86,2.1,2.1,0,0,0-.92,1.73,2,2,0,0,0,.73,1.56A2.74,2.74,0,0,0,391.94,201.36Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.79,201.67h-.5v-6.73a3.41,3.41,0,0,0-.66-2.25,2.66,2.66,0,0,0-2.08-.73,3.19,3.19,0,0,0-2.7,1.45,5,5,0,0,0-.83,1.93v6.33h-.51v-10H400V194a4.28,4.28,0,0,1,1.46-1.9,3.88,3.88,0,0,1,4.16-.11,2.78,2.78,0,0,1,1.05,1.82,3.74,3.74,0,0,1,1.44-1.73,4.07,4.07,0,0,1,2.25-.64,3,3,0,0,1,2.41.92,4.08,4.08,0,0,1,.8,2.75v6.54h-.5v-6.5a3.76,3.76,0,0,0-.66-2.44,2.51,2.51,0,0,0-2.08-.77,3.49,3.49,0,0,0-2.89,1.45,3.09,3.09,0,0,0-.67,1.59Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.13,191l-.34-.29a3.59,3.59,0,0,0,.81-2v-1.27h.5v1.08A3.61,3.61,0,0,1,415.13,191Zm1.69,0-.34-.29a3.59,3.59,0,0,0,.81-2v-1.27h.5v1.08A3.61,3.61,0,0,1,416.82,191Z",
    style: {
      fill: "#101905"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.9,
    y: 241.34,
    width: 171.97,
    height: 45.14,
    rx: 2.72,
    style: {
      fill: "#4e97fd"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(224.47 270.3)",
    style: {
      fontSize: 18,
      fill: "#fcfcfc",
      fontFamily: "Roboto-Regular, Roboto"
    }
  }, "SHOP NOW"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(184.47 119.58)",
    style: {
      fontSize: 48,
      fill: "#1d334f",
      fontFamily: "Roboto-Black, Roboto",
      fontWeight: 800,
      letterSpacing: "0.20000203450520834em"
    }
  }, "GENERIC MEDICINE"), /*#__PURE__*/React.createElement("line", {
    x1: 185.92,
    y1: 139.39,
    x2: 304.2,
    y2: 139.39,
    style: {
      fill: "#1d334f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.81 93.39 59.66 93.39 59.66 76.24 40.86 76.24 40.86 93.39 23.71 93.39 23.71 112.19 40.86 112.19 40.86 129.34 59.66 129.34 59.66 112.19 76.81 112.19 76.81 93.39",
    style: {
      fill: "#5e9fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.29 165.78 98.58 165.78 98.58 157.08 89.04 157.08 89.04 165.78 80.33 165.78 80.33 175.33 89.04 175.33 89.04 184.04 98.58 184.04 98.58 175.33 107.29 175.33 107.29 165.78",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.08 336.87 96.38 336.87 96.38 328.17 86.83 328.17 86.83 336.87 78.12 336.87 78.12 346.42 86.83 346.42 86.83 355.13 96.38 355.13 96.38 346.42 105.08 346.42 105.08 336.87",
    style: {
      fill: "#5e9fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.07,82.3l2.14-1.84-1.72-2,21.57-18.52a2.39,2.39,0,0,0,.65-.9h0a2.34,2.34,0,0,0-.4-2.39l-.82-1,8-6.9-1-1.18-8,6.9-.65-.75a2.33,2.33,0,0,0-2.3-.75h0a2.27,2.27,0,0,0-1,.5L112,72l-1.72-2-2.14,1.84,3.34,3.88-3.08,2.65-.89-1-3.58.16,6.95,8.09.7-3.52-.89-1,3.08-2.64Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.82,288.37l-3-3.49-3.28,2.81L62.28,252.44a3.81,3.81,0,0,0-1.48-1.06h0a3.8,3.8,0,0,0-3.9.65l-1.56,1.34L44.06,240.23l-1.93,1.66L53.41,255l-1.23,1A3.82,3.82,0,0,0,51,259.84h0a3.83,3.83,0,0,0,.82,1.62L82,296.71l-3.28,2.81,3,3.5,6.35-5.45,4.32,5-1.69,1.46L91,309.9l13.23-11.36-5.75-1.13-1.69,1.45-4.32-5Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.76,26.93l-2.92-5.35a6.42,6.42,0,0,0-11.27,6.15l2.92,5.36Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.59,35.16l3.5,6.4a6.42,6.42,0,1,0,11.26-6.15L188.86,29Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.71,32.13,277.34,35a6.42,6.42,0,0,0,6.1,11.3l5.37-2.9Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.89,42.34l6.42-3.46a6.42,6.42,0,0,0-6.1-11.3l-6.43,3.47Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.15,59.25a9.17,9.17,0,0,0-14.63-10.79Z",
    style: {
      fill: "#5e9fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.82,50.91A9.17,9.17,0,0,0,234.31,61.6Z",
    style: {
      fill: "#5e9fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54,224.9a9.17,9.17,0,0,0-12.41,13.28Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.37,240.15A9.17,9.17,0,0,0,159.66,227Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.13,175.14a9.16,9.16,0,0,0-17.7,4.08Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.18,182.11a9.17,9.17,0,0,0,17.54-4.05Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "857.93 168.85 849.22 168.85 849.22 160.14 839.68 160.14 839.68 168.85 830.97 168.85 830.97 178.39 839.68 178.39 839.68 187.1 849.22 187.1 849.22 178.39 857.93 178.39 857.93 168.85",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "855.72 339.94 847.01 339.94 847.01 331.23 837.47 331.23 837.47 339.94 828.76 339.94 828.76 349.48 837.47 349.48 837.47 358.19 847.01 358.19 847.01 349.48 855.72 349.48 855.72 339.94",
    style: {
      fill: "#5e9fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.71,85.36l2.14-1.84-1.72-2L889.7,63a2.24,2.24,0,0,0,.65-.9h0a2.34,2.34,0,0,0-.4-2.39l-.82-1,8-6.9-1-1.19-8,6.91-.65-.76a2.33,2.33,0,0,0-2.3-.75h0a2.33,2.33,0,0,0-1,.5L862.61,75.09l-1.72-2-2.14,1.84,3.34,3.89L859,81.45l-.89-1-3.58.15,7,8.1.69-3.52-.88-1,3.07-2.64Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.46,291.44l-3-3.5-3.27,2.81L812.92,255.5a3.81,3.81,0,0,0-1.48-1.06h0a3.84,3.84,0,0,0-3.9.65L806,256.43,794.7,243.3,792.77,245l11.28,13.14-1.23,1.06a3.78,3.78,0,0,0-1.23,3.75h0a3.78,3.78,0,0,0,.82,1.62l30.26,35.25-3.28,2.82,3,3.49,6.36-5.45,4.31,5-1.68,1.45.25,5.86,13.23-11.36-5.75-1.14-1.69,1.45-4.32-5Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.4,30l-2.92-5.36a6.42,6.42,0,1,0-11.27,6.16l2.92,5.35Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.23,38.22l3.49,6.41A6.42,6.42,0,0,0,943,38.47l-3.49-6.4Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.35,35.2,1028,38.1a6.42,6.42,0,1,0,6.1,11.29l5.37-2.9Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.53,45.41l6.42-3.47a6.42,6.42,0,0,0-6.11-11.3l-6.42,3.47Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.78,62.31a9.16,9.16,0,0,0-14.62-10.79Z",
    style: {
      fill: "#5e9fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.46,54a9.17,9.17,0,0,0,14.48,10.69Z",
    style: {
      fill: "#5e9fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.18,228a9.17,9.17,0,0,0-12.41,13.28Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898,243.22a9.18,9.18,0,0,0,12.29-13.16Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.92,114.37a9.17,9.17,0,0,0-17.71,4.09Z",
    style: {
      fill: "#d4e3f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774,121.34a9.17,9.17,0,0,0,17.54-4Z",
    style: {
      fill: "#d4e3f9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider1);
export default __webpack_public_path__ + "static/media/slider-1.2c659453773734439a6f1dcf808c8435.svg";
export { ForwardRef as ReactComponent };